import { createContext, useContext, useState, useCallback } from "react";
import PlayerCardModal from "@/components/PlayerCardModal";

const PlayerCardContext = createContext(null);

export function PlayerCardProvider({ children }) {
  const [playerId, setPlayerId] = useState(null);
  const openPlayerCard = useCallback((id) => { if (id) setPlayerId(id); }, []);
  return (
    <PlayerCardContext.Provider value={{ openPlayerCard }}>
      {children}
      <PlayerCardModal playerId={playerId} onClose={() => setPlayerId(null)} />
    </PlayerCardContext.Provider>
  );
}

export function usePlayerCard() {
  return useContext(PlayerCardContext) || { openPlayerCard: () => {} };
}
